import type { HtmlContent } from '@/core/types';

import { HtmlBlock } from '@/containers/blocks/html';

export default function generate({
  content,
  className,
}: {
  content: HtmlContent;
  className?: string;
}) {
  return (
    <HtmlBlock
      title={content.title}
      titleTag={content.titleTag}
      description={content.description}
      data={content.data}
      className={className}
    />
  );
}
